import { AlertLineSuggestedNoteDTO } from "src/models/alert-line-suggested-note/alert-line-suggested-note-dto";
import { BaseApiService } from "../base";
import { STOModel } from "src/models/base/sto-model";
import { AlertLineOrderedsuggestedNoteDTO } from "src/models/alert-line-suggested-note/alert-line-ordered-suggested-note-dto";

export class AlertLineOrderedSuggestedNotesApiService extends BaseApiService<
  AlertLineOrderedsuggestedNoteDTO,
  STOModel
> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/GetAlertLineOrderedSuggestedNotes",
    });
  }
}
